import { render } from "./ThePopupRemind.vue?vue&type=template&id=6b49432e&scoped=true"
import script from "./ThePopupRemind.vue?vue&type=script&lang=js"
export * from "./ThePopupRemind.vue?vue&type=script&lang=js"

import "./ThePopupRemind.vue?vue&type=style&index=0&id=6b49432e&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b49432e"]])

export default __exports__